import { jsx as _jsx } from "react/jsx-runtime";
import GeminiTeamSummary from '@web/components/Apps/Gemini/GeminiTeamSummary';
import GeminiUserSummary from '@web/components/Apps/Gemini/GeminiUserSummary';
import { useFilters } from '@web/utility/hooks/useFilters';
function GeminiSummary() {
    var user = useFilters().user;
    return user ? _jsx(GeminiUserSummary, { userId: user }) : _jsx(GeminiTeamSummary, {});
}
export default GeminiSummary;
